import RichUpdatesCreator from './RichUpdatesCreator';

export default RichUpdatesCreator;



// WEBPACK FOOTER //
// ./src/components/RichUpdates/RichUpdatesCreator/index.tsx